<template>
  <div class="bg-white p-2 w-full border rounded">
    <v-date-picker
      v-model="selected.date"
      color="blue"
      :disabled-dates="disableDates"
      :model-config="modelConfig"
    >
      <template #default="{ togglePopover, hidePopover }">
        <div class="d-flex flex-wrap">
          <button
            type="button"
            v-for="(date, index) in dates"
            :key="'date' + index"
            class="d-flex align-items-center btn btn-primary mb-2 me-2 px-2"
            @click.stop="dateSelected($event, date, togglePopover)"
            ref="button"
          >
            {{ new Date(date.date).format("yyyy-MM-dd") }}
            <svg
              class="ms-2"
              style="width: 16px; height: 16px"
              viewBox="0 0 24 24"
              stroke="currentColor"
              stroke-width="2"
              @click.stop="removeDate(date, hidePopover)"
            >
              <path d="M6 18L18 6M6 6l12 12"></path>
            </svg>
          </button>
        </div>
      </template>
    </v-date-picker>
    <button type="button" class="btn btn-outline-primary" @click.stop="addDate">
      + Add Date
    </button>
  </div>
</template>

<script>
export default {
  props: ['value', 'clear'],
  data () {
    return {
      dates: [],
      selected: {},
      modelConfig: {
        type: 'string',
        mask: 'YYYY-MM-DD'
      }
    }
  },
  computed: {
    disableDates () {
      const vm = this
      const dates = []
      vm.dates.forEach((ele) => {
        if (vm.selected.date === ele.date) return
        dates.push({
          start: ele.date,
          end: ele.date
        })
      })
      return dates
    }
  },
  watch: {
    clear (data) {
      if (data) {
        this.dates = []
      }
    },
    dates: {
      handler (data) {
        const newDates = []
        if (data) {
          data.forEach((ele) => {
            newDates.push(ele.date)
          })
          if (JSON.stringify(newDates) !== JSON.stringify(this.value)) {
            this.updateInput()
          }
        }
      },
      deep: true
    },
    value (data) {
      const newDates = []
      if (data) {
        data.forEach((ele) => {
          newDates.push({
            date: ele
          })
        })
        if (JSON.stringify(newDates) !== JSON.stringify(this.dates)) {
          this.dates = newDates
        }
      }
    }
  },
  methods: {
    updateInput () {
      const vm = this
      const dates = []
      vm.dates.forEach((ele) => {
        dates.push(new Date(ele.date).format('yyyy-MM-dd'))
      })
      vm.$emit('input', dates)
    },
    addDate () {
      this.dates.push({
        date: new Date()
      })
      this.$nextTick(() => {
        const btn = this.$refs.button[this.$refs.button.length - 1]
        btn.click()
      })
    },
    removeDate (date, hide) {
      this.dates = this.dates.filter((d) => d !== date)
      hide()
    },
    dateSelected (e, date, toggle) {
      this.selected = date
      toggle({ ref: e.target })
    }
  },
  mounted () {
    this.dates = []
  }
}
</script>
